module.exports = new __parcel__URL__("castedfear.8e2d5f6c.png").toString();